import React from 'react'
import moment from 'moment';
import Button from 'components/Button'
import Tooltip from '@material-ui/core/Tooltip';
import './RequestSuccess.scss';

const RequestSuccess = (
  {
    request,
    success_message,
    onContinue = () => {
    },
    onShare = () => {
    }
  }
) => {
  const date = moment(request.date)

  return (
    <div className="request-success-container">
      <div className="Grid Grid--center">
        <div className="Grid-column Grid--center full-width">
          <span className="icon-calendar-full background-blue"/>
        </div>
        <div className="Grid-column Grid--center">
          {/* {request.verified
            ?
            <h3>Seu horário está agendado!</h3>
            :
            <h3>Seu agendamento foi solicitado!
              <br/>Aguarde a confirmação do realizador.
            </h3>
          } */}
          <h3>Seu horário está agendado!</h3>
        </div>
        <div className="Grid-row Grid--center">
          <div className="Grid-cell">
            <h4 className="request-date"><span className="icon-calendar-full"/> {date.format("DD/MM/YYYY")}</h4>
          </div>
          <div className="Grid-cell">
            <h4 className="request-hour"><span className="icon-clock"/> {date.format("HH:mm")}</h4>
          </div>
        </div>
        {!!success_message && 
        <div className="Grid-column Grid--left clear-inner reset-text" dangerouslySetInnerHTML={{ __html: success_message }}>
        </div>}
        <div className="Grid-column Grid--center">
          <p>
            Você poderá efetuar o pagamento da sua vaga e compartilhar essa aventura com seus amigos.
          </p>
        </div>
        <div className="Grid-buttons Grid Grid--center">
          <Button value="AVANÇAR" type="green" size="full" className="full-width"
                  onClick={() => onContinue(request.short_url)}/>
        </div>
        <div className="Grid-buttons Grid Grid--center">
          <Button value="COMPARTILHAR" type="blue" size="full" className="full-width"
                  onClick={() => onShare(request.short_url)}/>
        </div>
        <div className="help">
          <Tooltip title={
            <React.Fragment>
              <p>Dúvidas sobre o agendamento, nobre aventureiro(a)? Não tem segredo, se liga:</p>
              <p>Primeiramente, você agenda um horário com o realizador. Assim, esse horário é seu e ficará indisponível
                para outras pessoas. Você não paga nada para agendar horários com realizadores através do Adrena. </p>
              <p>Com o agendamento confirmado, você recebe um link exclusivo da sua aventura. Nesse link você reserva
                sua vaga, podendo pagar antecipadamente pela plataforma, e compartilha com seus amigos, para que eles
                também garantam suas participações.</p>
              <p>E pronto! É só curtir a sua próxima aventura. Se precisar cancelar, confira as regras de cancelamento
                do realizador, ou troque uma ideia com ele.</p>
              <p>O Adrena não é responsável pela realização da aventura, somente pela intermediação de agendamentos e
                pagamentos entre aventureiros e realizadores.</p>
            </React.Fragment>
          }>
            <span className="tooltip-helper">?</span>
          </Tooltip>
          <Tooltip title={
            <React.Fragment>
              <p>Dúvidas sobre o agendamento, nobre aventureiro(a)? Não tem segredo, se liga:</p>
              <p>Primeiramente, você agenda um horário com o realizador. Assim, esse horário é seu e ficará indisponível
                para outras pessoas. Você não paga nada para agendar horários com realizadores através do Adrena. </p>
              <p>Com o agendamento confirmado, você recebe um link exclusivo da sua aventura. Nesse link você reserva
                sua vaga, podendo pagar antecipadamente pela plataforma, e compartilha com seus amigos, para que eles
                também garantam suas participações.</p>
              <p>E pronto! É só curtir a sua próxima aventura. Se precisar cancelar, confira as regras de cancelamento
                do realizador, ou troque uma ideia com ele.</p>
              <p>O Adrena não é responsável pela realização da aventura, somente pela intermediação de agendamentos e
                pagamentos entre aventureiros e realizadores.</p>
            </React.Fragment>
          }>
            <p>Duvidas sobre agendamento?</p>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default RequestSuccess
